import { render, staticRenderFns } from "./scroll-bar.vue?vue&type=template&id=c8654a48&"
import script from "./scroll-bar.vue?vue&type=script&lang=js&"
export * from "./scroll-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports